// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".UploadNodes__description___209_L{padding:16px}.UploadNodes__tableWrapper___2-aoZ{max-height:200px;overflow-y:scroll}.UploadNodes__dataPreview___2gpfL{padding:16px 0px}.UploadNodes__row___QpnWK{display:flex;align-items:center;margin-top:8px}.UploadNodes__input___fZXAY{margin-bottom:12px}.UploadNodes__sampleResponse___goTPJ{background:whitesmoke;border:1px solid #ddd;padding:8px;border-radius:16px;border-top-left-radius:4px}.UploadNodes__extraResponses___3Gsss{font-size:12px;font-style:italic;color:#848484}\n", ""]);
// Exports
exports.locals = {
	"description": "UploadNodes__description___209_L",
	"tableWrapper": "UploadNodes__tableWrapper___2-aoZ",
	"dataPreview": "UploadNodes__dataPreview___2gpfL",
	"row": "UploadNodes__row___QpnWK",
	"input": "UploadNodes__input___fZXAY",
	"sampleResponse": "UploadNodes__sampleResponse___goTPJ",
	"extraResponses": "UploadNodes__extraResponses___3Gsss"
};
module.exports = exports;
